import React from 'react';
import GoalItem from './GoalItem';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar } = FiIcons;

function GoalsList({ goals, onToggleGoal, onDeleteGoal }) {
  const dailyGoals = goals.filter(goal => goal.type === 'daily');
  const weeklyGoals = goals.filter(goal => goal.type === 'weekly');
  const monthlyGoals = goals.filter(goal => goal.type === 'monthly');
  const annualGoals = goals.filter(goal => goal.type === 'annual');

  const renderGoalSection = (sectionGoals, title, gradientClass) => {
    const pendingCount = sectionGoals.filter(g => !g.completed).length;
    
    return (
      <div className="mb-10">
        <div className="flex items-center mb-6">
          <div className={`${gradientClass} p-3 rounded-2xl mr-4 shadow-lg`}>
            <SafeIcon icon={FiCalendar} className="text-white text-2xl" />
          </div>
          <h2 className={`text-2xl font-bold bg-clip-text text-transparent ${gradientClass.replace('bg-', 'bg-')}`}>
            {title}
          </h2>
          <span className="ml-3 px-3 py-1 bg-gray-100 text-gray-600 text-sm font-semibold rounded-full">
            {pendingCount} da fare
          </span>
        </div>
        <div>
          {sectionGoals.length === 0 ? (
            <p className="text-gray-500 italic p-6 bg-gradient-to-r from-gray-50 to-white rounded-3xl shadow-lg border border-gray-100">
              Nessun obiettivo in questa sezione.
            </p>
          ) : (
            sectionGoals.map(goal => (
              <GoalItem
                key={goal.id}
                goal={goal}
                onToggle={onToggleGoal}
                onDelete={onDeleteGoal}
              />
            ))
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {renderGoalSection(dailyGoals, "Obiettivi Giornalieri", "bg-gradient-to-r from-blue-500 to-cyan-500")}
      {renderGoalSection(weeklyGoals, "Obiettivi Settimanali", "bg-gradient-to-r from-green-500 to-emerald-500")}
      {renderGoalSection(monthlyGoals, "Obiettivi Mensili", "bg-gradient-to-r from-orange-500 to-amber-500")}
      {renderGoalSection(annualGoals, "Obiettivi Annuali", "bg-gradient-to-r from-purple-500 to-violet-500")}
    </>
  );
}

export default GoalsList;